module.exports = __webpack_public_path__ + "files/dd02d24dd0a777c279dea50548743886.png";